import {PARSE_PROP_CONF_KEY, PACKAGE_NAME} from '../../constants';
import isValuePropertySelector from './isValuePropertySelector';
import {
	sandbox,
	locations,
	toLower,
	kebabCase,
	allLogTypes as logTypes
} from '@servicenow/ui-internal';
import log from '../../log';
import {default as validParseTypes} from './types';
import {parseRefProperty} from './refProperty';
import parse from './parse';

/**
 * Parse any property that is configured with `unstableParse: true`, or any property that has a
 * defined schema with a parseable type
 */
export default function parseProperties(properties, defs = {}, {host, dispatch}) {
	const parsedProperties = {};
	for (const k in properties) {
		const value = properties[k];
		const unstableParse = defs[k] && defs[k][PARSE_PROP_CONF_KEY];

		const schemaType = defs[k] && defs[k].schema && defs[k].schema.type;
		const isValidParseType = validParseTypes.includes(schemaType);
		const resolvedValue = defs[k] && defs[k].resolveRef ? parseRefProperty(host, k, value) : value;
		const shouldUnstableParse =
			(unstableParse || validParseTypes.includes(schemaType)) &&
			!isValuePropertySelector(resolvedValue) &&
			typeof resolvedValue === 'string';

		if (shouldUnstableParse && isValidParseType && !host.hasAttribute(kebabCase(k))) {
			const component = `<${toLower(host.tagName)} />`;
			log(
				`For property ${k} on component ${component}: expected to be type ${schemaType} but received string. ${PACKAGE_NAME} will attempt to parse this value, but you should set this to the correct type.`,
				{level: logTypes.WARN, host, origin: 'parseProperties'}
			);
		}

		parsedProperties[k] = shouldUnstableParse
			? sandbox(parse, {
					args: [resolvedValue, schemaType, k, host.tagName],
					host,
					dispatch,
					location: locations.PROPERTY,
					details: {parse: true, name: k},
					log
			  })
			: resolvedValue;
	}

	return parsedProperties;
}
